import { france } from './countries/france';
import { spain } from './countries/spain';
import { portugal } from './countries/portugal';
import { ireland } from './countries/ireland';
import { poland } from './countries/poland';
import { italy } from './countries/italy';
import { czech } from './countries/czech';
import { slovenia } from './countries/slovenia';
import { sweden } from './countries/sweden';
import { denmark } from './countries/denmark';
import { malta } from './countries/malta';
import { cyprus } from './countries/cyprus';
import { croatia } from './countries/croatia';
import { belarus } from './countries/belarus';
import { estonia } from './countries/estonia';
import { georgia } from './countries/georgia';
import { lithuania } from './countries/lithuania';
import { greece } from './countries/greece';
import { latvia } from './countries/latvia';
import { norway } from './countries/norway';
import { australia } from './countries/australia';
import { uae } from './countries/uae';
import { bosnia } from './countries/bosnia';
import { slovakia } from './countries/slovakia';
import { canada } from './countries/canada';
import { finland } from './countries/finland';

export const countries = [
  france,
  spain,
  portugal,
  ireland,
  poland,
  italy,
  czech,
  slovenia,
  sweden,
  denmark,
  malta,
  cyprus,
  croatia,
  belarus,
  estonia,
  georgia,
  lithuania,
  greece,
  latvia,
  norway,
  australia,
  uae,
  bosnia,
  slovakia,
  canada,
  finland
];

export * from './countries/types';